var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center u-fill-height visible" },
    [
      _c("ob1-progress-indicators", {
        staticClass: "my-auto",
        attrs: { size: 50, type: "undetermined" },
      }),
      _vm._v(" "),
      _vm.confirmationMessage
        ? _c("FeedbackModalDialog", {
            ref: "feedbackConfirmationDialog",
            attrs: {
              id: "confirmationDialog",
              "modal-content": _vm.confirmationMessage.text,
              "modal-title": _vm.confirmationMessage.title,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "actionButton",
                  fn: function () {
                    return [
                      _c("bouton", {
                        attrs: {
                          label: _vm.confirmationMessage.buttonLabel,
                          "is-primary": false,
                        },
                        on: { click: _vm.initConfirmationCart },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2481718617
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }